// useRandomItem.js
export const randomItem = (arr) => arr[Math.floor(Math.random() * arr.length)];
